import { api } from "./axios";

export async function getQuestions() {
    let res = await api.get("questions/all");
    if (res) return res.data.data;
    else return false;
}
export async function deleteQuestions(questionId) {
    let res = await api.get("questions/destroy/" + questionId);
    if (res) return res.data.data;
    else return false;
}
export async function createQuestions(data) {
    let res = await api.post("questions/store", data);
    if (res) return res.data.data;
    else return false;
}
export async function getQuestionsDtails(id) {
    let res = await api.get("questions/show/" + id);
    if (res) return res.data.data;
    else return false;
}
export async function UpdateQuestionsDtails(id, data) {
    let res = await api.post("questions/update/" + id, data);
    if (res) return res.data.data;
    else return false;
}

